export default function Supplier() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Опыт работы',
      description: 'Поставка промышленного подъёмного оборудования более 15 лет'
    },
    {
      icon: 'ri-store-line',
      title: 'Собственный склад',
      description: 'Прямые контракты с заводами-производителями оборудования'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Инженерная поддержка',
      description: 'Консультации по подбору и эксплуатации оборудования'
    },
    {
      icon: 'ri-truck-line',
      title: 'Поставка по РФ и СНГ',
      description: 'Работа по договору, с НДС, полный пакет документов'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12">Поставщик</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((item, index) => (
            <div key={index} className="flex flex-col items-start">
              <div className="w-16 h-16 sm:w-18 sm:h-18 bg-blue-50 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-[#1A2B4A] text-3xl sm:text-4xl`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}